
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface VariantsFiltersProps {
  factories: any[];
  products: any[];
  filters: {
    factory: string;
    product: string;
    name: string;
  };
  onFilterChange: (key: string, value: string) => void;
  onClearFilters: () => void;
  loading?: boolean;
}

export function VariantsFilters({
  factories,
  products,
  filters,
  onFilterChange,
  onClearFilters,
  loading = false
}: VariantsFiltersProps) {
  const hasActiveFilters = Object.values(filters).some(value => value !== "" && value !== "all");

  return (
    <div className="bg-white p-4 rounded-lg border mb-4 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-semibold">Filters</h3>
        {hasActiveFilters && (
          <Button
            variant="outline"
            size="sm"
            onClick={onClearFilters}
            className="flex items-center gap-2"
          >
            <X className="h-4 w-4" />
            Clear All
          </Button>
        )}
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <div className="space-y-2">
          <label className="text-sm font-medium">Factory</label>
          <Select
            value={filters.factory || "all"}
            onValueChange={(value) => onFilterChange("factory", value === "all" ? "" : value)}
            disabled={loading}
          >
            <SelectTrigger>
              <SelectValue placeholder="All Factories" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Factories</SelectItem>
              {factories.map((factory) => (
                <SelectItem key={factory.id} value={factory.id}>
                  {factory.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Product</label>
          <Select
            value={filters.product || "all"}
            onValueChange={(value) => onFilterChange("product", value === "all" ? "" : value)}
            disabled={loading}
          >
            <SelectTrigger>
              <SelectValue placeholder="All Products" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Products</SelectItem>
              {products.map((product) => (
                <SelectItem key={product.id} value={product.id}>
                  {product.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Variant Name</label>
          <Input
            placeholder="Filter by variant name..."
            value={filters.name}
            onChange={(e) => onFilterChange("name", e.target.value)}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );
}
